<template>
  <article class="team-card">
    <div>
      <span><img :src="img" class="team-img" /></span>
    </div>
    <h3>{{ name }}</h3>
    <p>{{ role }}</p>
    <a href="#" style="display: none;" aria-label="LinkedIn profile">in</a>
  </article>
</template>
<style scoped>
.team-img{
  object-fit: cover;
  max-width:100%;
  margin:0 auto;
  height:170px;
  width:170px;
  display:inline-block;
}
</style>
<script>
export default {
  name: 'TeamCard',
  props: {
    name: { type: String, required: true },
    role: { type: String, required: true },
    tone: { type: String, default: 'blue' },
    img: { type: String, required: true },
  },
  computed: {
    
  }
};
</script>
